import React from 'react';
import theme from 'src/shared/theme';
import styled from 'styled-components';

type Tool = {
    name: string;
    tooltip: string;
    icon: React.ReactNode;
    onClick: () => void;
    disabled?: boolean;
};

type ToolGridProps = {
    tools: Tool[];
    columns?: number;
};

const OuterWrapper = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    box-sizing: border-box;
    padding: 10px 0px;
`;

const GridContainer = styled.div<{ columns: number }>`
    display: grid;
    grid-template-columns: repeat(${(props) => props.columns}, minmax(0, 1fr));
    width: fit-content;
    gap: 10px;
`;

const ToolButton = styled.button`
    display: flex;
    flex-direction: column;
    align-items: center;
    background: none;
    border: none;
    cursor: pointer;
    min-width: 0;
    transition: all 0.2s ease;
    border-radius: 4px;
    padding: 8px;

    &:hover {
        opacity: 0.8;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
        background-color: rgba(0, 0, 0, 0.02);
    }

    &:disabled {
        cursor: not-allowed;
        opacity: 0.5;
    }

    svg {
        width: 20px;
        height: 20px;
        flex-shrink: 0;
        margin-bottom: 4px;
    }
`;

const ToolName = styled.div`
    font-size: 10px;
    text-align: center;
    word-break: normal;
`;

export const ToolGrid: React.FC<ToolGridProps> = ({ tools, columns = 5 }) => {
    return (
        <OuterWrapper>
            <GridContainer columns={columns}>
                {tools.map((tool, idx) => (
                    <ToolButton key={idx} title={tool.tooltip} onClick={tool.onClick} disabled={tool.disabled}>
                        {React.isValidElement(tool.icon)
                            ? React.cloneElement(tool.icon as React.ReactElement, {
                                  style: { opacity: tool.disabled ? theme.app.disabledOpacity : 1 }
                              })
                            : tool.icon}
                        <ToolName>{tool.name}</ToolName>
                    </ToolButton>
                ))}
            </GridContainer>
        </OuterWrapper>
    );
};
